import { PropsWithChildren } from 'react';

import { Button, Dialog } from 'libs/ui';

import { ConfirmationDialogContent } from './ConfirmationDialogContent';
import { ConfirmationDialogProps } from './types';

export const ConfirmationDialog = ({
  title,
  subtitle,
  confirmButtonLabel,
  backButtonLabel,
  onConfirm,
  onBack,
  children,
  className,
  loading,
  headerCentered,
  buttonConfirm,
  hideButtonConfirm,
  hideBackButton,
  confirmButtonColorVariant,
  confirmButtonDisabled,
  ...dialogProps
}: ConfirmationDialogProps & PropsWithChildren) => {
  const ButtonConfirm = buttonConfirm ?? Button;

  return (
    <Dialog className={className} maxWidth="lg" {...dialogProps}>
      <ConfirmationDialogContent
        backButtonLabel={backButtonLabel}
        buttonConfirm={ButtonConfirm}
        className={className}
        confirmButtonColorVariant={confirmButtonColorVariant}
        confirmButtonDisabled={confirmButtonDisabled}
        confirmButtonLabel={confirmButtonLabel}
        headerCentered={headerCentered}
        hideBackButton={hideBackButton}
        hideButtonConfirm={hideButtonConfirm}
        loading={loading}
        subtitle={subtitle}
        title={title}
        onBack={onBack}
        onConfirm={onConfirm}
      >
        {children}
      </ConfirmationDialogContent>
    </Dialog>
  );
};
